import { Buoy, StartFinishLine } from '../types';

// Buoys laid out for a classic windward-leeward course
// Positions are in percentage of canvas size (0-100) for scaling
// Adjusted to stay within water area (away from right and top coastline)
export const DEFAULT_BUOYS_PERCENT: Buoy[] = [
  { id: 0, position: { x: 40, y: 25 }, radius: 12, roundingDirection: 'port' },      // Top mark (windward)
  { id: 1, position: { x: 70, y: 50 }, radius: 12, roundingDirection: 'starboard' }, // Right gate
  { id: 2, position: { x: 40, y: 80 }, radius: 12, roundingDirection: 'port' },      // Bottom mark (leeward)
  { id: 3, position: { x: 15, y: 50 }, radius: 12, roundingDirection: 'starboard' }, // Left gate
];

// Start/finish line near center-bottom
export const START_FINISH_LINE_PERCENT: StartFinishLine = {
  start: { x: 30, y: 65 },
  end: { x: 50, y: 65 },
};

// Scale buoys to actual canvas size
export function scaleBuoys(buoysPercent: Buoy[], width: number, height: number): Buoy[] {
  return buoysPercent.map(buoy => ({
    ...buoy,
    position: {
      x: (buoy.position.x / 100) * width,
      y: (buoy.position.y / 100) * height,
    },
  }));
}

// Scale start/finish line to actual canvas size
export function scaleStartFinishLine(
  linePercent: StartFinishLine,
  width: number,
  height: number
): StartFinishLine {
  return {
    start: {
      x: (linePercent.start.x / 100) * width,
      y: (linePercent.start.y / 100) * height,
    },
    end: {
      x: (linePercent.end.x / 100) * width,
      y: (linePercent.end.y / 100) * height,
    },
  };
}

// Rounding zone radius (how close you need to get to start rounding)
export const ROUNDING_ZONE_RADIUS = 60;

// How far past the buoy you need to go to complete the rounding
export const ROUNDING_COMPLETE_DISTANCE = 50;
